import { SvgIcon } from "@mui/material"

import { ReactComponent as Safety } from "./SectionIcon.svg"

export const SectionIcon = (props) => {
    return (
        <SvgIcon component={Safety} {...props} inheritViewBox />
    )
}